import rawData from "./emoji-data.json";

export interface EmojiEntry {
  emoji: string;
  name: string;
  slug: string;
  keywords: string[];
  unicode_version: string;
  emoji_version: string;
  skin_tone_support: boolean;
}

export interface EmojiCategory {
  name: string;
  slug: string;
  emojis: EmojiEntry[];
}

export const emojiData = rawData as Record<string, EmojiCategory>;
